import React from "react";

export default function QueueRankChip({ rank, id }) {
  if (!rank) return null;
  return (
    <span
      className="inline-flex items-center justify-center h-5 min-w-[20px] px-1 rounded-full bg-amber-100 text-amber-800 text-[10px] font-bold tabular-nums shrink-0"
      title={`#${rank} in your follow queue`}
      data-testid={`queue-rank-${id}`}
    >
      {rank}
    </span>
  );
}
